import { take, put, call, all, takeLatest } from 'redux-saga/effects';
import moment from 'moment';

import {
  initPagePreviewInfo,

  requestPagePreviewStart,
  requestPagePreviewSuccess,
  requestPagePreviewFail,

  requestDetailPagePreviewStart,
  requestDetailPagePreviewSuccess,
  requestDetailPagePreviewFail,
} from '../actions/template-management';

import requestManagement from '../service/requestManagement';

const { method_POST, method_GET, method_PATCH } = requestManagement;

import CONFIG from '@root/config/config.next';
const url = CONFIG.backendEndpoint;

export function* requestPagePreview({ payload }) {

  /*console.log('[sages] requestPagePreview : ', payload);*/

  const apiURL = `${url}/backend/v2/cms${payload?.uuid}/preview`;

  //====================================================================================================================

  try {
    const data = yield method_GET(
      {
        url: apiURL,
      });

    /*console.log("[sages] requestPagePreview : GET : ",);*/

    yield put(requestPagePreviewSuccess(data));

  } catch (error) {
    yield put(requestPagePreviewFail(error));
  }

  //====================================================================================================================
}

export function* requestDetailPagePreview({ payload }) {

  /*console.log('[sages] requestDetailPagePreview : ', payload);*/

  const apiURL = `${url}/backend/v2/cms/${payload?.uuid}`;

  //====================================================================================================================

  try {
    const data = yield method_GET(
      {
        url: apiURL,
      });

    /*console.log("[sages] requestDetailPagePreview : GET : ",);*/

    yield put(requestDetailPagePreviewSuccess(data));

  } catch (error) {
    yield put(requestDetailPagePreviewFail(error));
  }

  //====================================================================================================================
}



export function* watchTemplateManagement() {

  /*console.log('[sages] watchTemplateManagement : ✅');*/

  yield all([
    takeLatest(requestPagePreviewStart, requestPagePreview),
    takeLatest(requestDetailPagePreviewStart, requestDetailPagePreview),
  ])
}



